import React from "react";

function HambugerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className="header-transition"
    >
      <path
        className="fill-current"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5459 6.36452C2.5459 5.66162 3.11572 5.0918 3.81863 5.0918H24.1823C24.8852 5.0918 25.455 5.66162 25.455 6.36452C25.455 7.06743 24.8852 7.63725 24.1823 7.63725H3.81863C3.11572 7.63725 2.5459 7.06743 2.5459 6.36452ZM2.5459 21.6373C2.5459 20.9343 3.11572 20.3645 3.81863 20.3645H24.1823C24.8852 20.3645 25.455 20.9343 25.455 21.6373C25.455 22.3402 24.8852 22.91 24.1823 22.91H3.81863C3.11572 22.91 2.5459 22.3402 2.5459 21.6373ZM3.81863 12.7282C3.11572 12.7282 2.5459 13.298 2.5459 14.0009C2.5459 14.7038 3.11572 15.2736 3.81863 15.2736H24.1823C24.8852 15.2736 25.455 14.7038 25.455 14.0009C25.455 13.298 24.8852 12.7282 24.1823 12.7282H3.81863Z"
      />
    </svg>
  );
}

export default HambugerIcon;
